import { render, staticRenderFns } from "./CycleChangePolicySitecore.vue?vue&type=template&id=45b4811a"
import script from "./CycleChangePolicySitecore.vue?vue&type=script&lang=js"
export * from "./CycleChangePolicySitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports